import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#b28e54',
        accent: '#b28e54',
      },
    },
  },
  icons: {
    iconfont: 'mdi', // default - only for display purposes
    dropdown: 'expand_more',
  },
})
